import styles from "./FeatureItem.module.css";
import Icon from "@mdi/react";
import { mdiChatOutline } from "@mdi/js";

//React
import React, { useState } from "react";

// Components
import FeatureInfo from "./FeatureInfo/FeatureInfo";
import FeatureUpvote from "./FeatureUpvote/FeatureUpvote";
import DropDownMenu from "components/DropDownMenu";
import { dropDownPublicationOptionsArray } from "tools/getPublication";
import { dropDownStatusOptionsArray } from "tools/getStatus";
import { dropDownPriorityOptionsArray } from "tools/getPriority";

// context
import { useContext } from "react";
import { MyContext } from "components/RoleContext";
import { Role } from "tools/Enums";

export default function FeatureItem(props) {
	const { role } = useContext(MyContext);
	const { feature, onChange, onChangeState, onClickDelete } = props;

	const handleItemSelected = async (dropDownItem, type) => {
		let value;
		// cast to bool
		if (type == "published") value = !!dropDownItem.id;
		else value = dropDownItem.id;
		const updatedFeature = {
			...feature,
			[type]: value,
		};
		props.onChange(updatedFeature);
	};

	return (
		<>
			<hr className={styles.hr} />
			<div className={styles.item}>
				{role === Role.Admin && <div className={styles.idFeature}>{props.feature.idFeature}</div>}
				<FeatureUpvote feature={feature} onChangeState={onChangeState} />
				<FeatureInfo feature={feature} />

				<div className={styles.dropdowns}>
					{feature.nbComments > 0 && (
						<div className={styles.wrapper}>
							<Icon path={mdiChatOutline} size={1.3} color="#1d70b8" className={styles.icon} />
							<div className={styles.nbComments}>{feature.nbComments}</div>
						</div>
					)}
					{role === Role.Admin && (
						<>
							<DropDownMenu
								items={dropDownPriorityOptionsArray}
								selectedItem={dropDownPriorityOptionsArray[props.feature.priority]}
								// width={{ width: 80 }}
								onSelect={handleItemSelected}
								type="priority"
							/>
							<DropDownMenu
								items={dropDownPublicationOptionsArray}
								selectedItem={dropDownPublicationOptionsArray[+props.feature.published]}
								// width={{ width: 80 }}
								onSelect={handleItemSelected}
								type="published"
							/>
							<DropDownMenu
								items={dropDownStatusOptionsArray}
								selectedItem={dropDownStatusOptionsArray[props.feature.status]}
								width={{ width: 150 }}
								onSelect={handleItemSelected}
								type="status"
							/>
						</>
					)}
				</div>
			</div>
		</>
	);
}
